import Role from './rbac.authorization.k8s.io.role';

export default { ...Role };
